export default __webpack_public_path__ + "static/media/worker1.158dc832.png";